export const handleAltArrowReorder = (items, id, event, dispatch, setItems) => {
  if (!event.altKey || (event.key !== 'ArrowUp' && event.key !== 'ArrowDown')) return;
  const direction = event.key === 'ArrowUp' ? -1 : 1;
  const index = items.findIndex((item) => item.id === id);
  const nextIndex = index + direction;
  if (index < 0 || nextIndex < 0 || nextIndex >= items.length) return;
  const updated = [...items];
  [updated[index], updated[nextIndex]] = [updated[nextIndex], updated[index]];
  dispatch(setItems(updated));
};
